import { createHref, type UrlObject } from "@src/shims/next/router-runtime";

export type Query = Record<string, string | string[] | undefined>;

export type Route = {
  pathname: string;
  query?: Query;
  hash?: string;
};

export type StaticRoute<T extends keyof Route = "pathname"> = Route[T] | Route;

export function route(routeValue: Route): string {
  const url: UrlObject = {
    pathname: routeValue.pathname,
    query: routeValue.query,
    hash: routeValue.hash,
  };

  return createHref(url);
}
